const DEFAULT_OSOBOWE_IMAGE = "/img/osobowe/nadwozie (8).png";
const DEFAULT_DOSTAWCZE_IMAGE = "/img/dostawcze/dostawcze(1).png";

// Mapa: nazwa nadwozia -> ścieżka obrazka dla aut osobowych.
export const OsoboweBodyTypeIcons = {
    "Hatchback":       "/img/osobowe/nadwozie (2).png",
    "Kombi":           "/img/osobowe/nadwozie (1).png",
    "Sedan":           "/img/osobowe/nadwozie (4).png",
    "SUV / Crossover": "/img/osobowe/nadwozie (10).png",
    "Coupe / Roadster":"/img/osobowe/nadwozie (11).png",
    "Kabriolet":       "/img/osobowe/nadwozie (5).png",
    "VAN / Bus":       "/img/osobowe/nadwozie (7).png",
    "Pick-Up":         "/img/osobowe/nadwozie (6).png",
    "Inne":            "/img/osobowe/nadwozie (8).png",
};

// Mapa: nazwa nadwozia -> ścieżka obrazka dla aut dostawczych.
export const DostawczeBodyTypeIcons = {
    "Chłodnia/Izoterma":    "/img/dostawcze/dostawcze(1).png",
    "Do Zabudowy":          "/img/dostawcze/dostawcze(10).png",
    "Doka":                 "/img/dostawcze/dostawcze(12).png",
    "Furgon":               "/img/dostawcze/dostawcze(3).png",
    "Kamper":               "/img/dostawcze/dostawcze(3).png",
    "Kontener":             "/img/dostawcze/dostawcze(7).png",
    "Skrzynia":             "/img/dostawcze/dostawcze(10).png",
    "Skrzynia z plandeką":  "/img/dostawcze/dostawcze(5).png",
    "Skrzynia z wywrotką":  "/img/dostawcze/dostawcze(4).png",
    "VAN / Bus":            "/img/dostawcze/dostawcze(11).png",
    "Pick-Up":              "/img/dostawcze/dostawcze(8).png",
    "Inne":                 "/img/dostawcze/dostawcze(2).png",
};

export function getBodyTypeImage(typeName, vehicleType) {
    if (vehicleType === "DOSTAWCZE") {
        return DostawczeBodyTypeIcons[typeName] || DEFAULT_DOSTAWCZE_IMAGE;
    }
    return OsoboweBodyTypeIcons[typeName] || DEFAULT_OSOBOWE_IMAGE;
}

const BodyTypeIcons = {osobowe: OsoboweBodyTypeIcons, dostawcze: DostawczeBodyTypeIcons};
export default BodyTypeIcons;
